//import React from 'react';
//import { Navigate } from 'react-router-dom';
//import { useAuth } from './AuthContext';

//import { usePermission } from '../hooks/usePermission';


////export const ProtectedRoute = ({ children }) => {
////  const { isAuthenticated } = useAuth();
////  return isAuthenticated ? children : <Navigate to="/login" replace />;
////};

//export const ProtectedRoute = ({ children, allowedRoles, page, section=null }) => {
//    const { isAuthenticated, user } = useAuth();
//    const { hasPageAccess } = usePermission();  



//    // Not authenticated
//    if (!isAuthenticated) {
//        return <Navigate to="/login" replace />;
//    }


//    if (user?.userRole?.trim().toLowerCase() === 'admin') {

//        console.log("---------------------------------------------------");
//        console.log("PAGE : " + page + "SECTION : " + section);
//        console.log("PAGE : " + page + "PAGE ACCESS : " + hasPageAccess(page, section));
//        console.log("---------------------------------------------------");

//        //alert(hasPageAccess(page));

//        // Check page permission
//        if (page && !hasPageAccess(page, section)) {


//            return <Navigate to="/" replace />;
//        }


//        //const hasAccess = hasPageAccess(page);



//        //if (!hasAccess) {
//        //    return <Navigate to="/" replace />;
//        //}

//    }

//    // Role restriction
//    if (
//        allowedRoles &&
//        !allowedRoles.includes(user?.userRole)
//    ) {

//      //  alert("ROLE INNER")
//        return <Navigate to="/" replace />;
//    }
//    //alert("ROLE OUTER")

//    //console.log("=============================");
//    //console.log("CHILDREN : "+JSON.stringify(children));
//    //console.log("=============================");

//    return children;
//};

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { usePermission } from '../hooks/usePermission';

export const ProtectedRoute = ({
    children,
    allowedRoles,
    page,
    section = null
}) => {
    const { isAuthenticated, user } = useAuth();
    const { hasPageAccess } = usePermission();

    const userRoleee = user?.userRole?.trim().toLowerCase();

    //console.log("=== ProtectedRoute Debug ===");
    //console.log("Role:", JSON.stringify(userRoleee));
    //console.log("Page:", JSON.stringify(page));
    //console.log("Section:", JSON.stringify(section));
    //console.log("Authenticated:", isAuthenticated);
    //console.log("Allowed roles:", allowedRoles);

    //console.log(
    //    "Page access:",
    //    page ? hasPageAccess(page, section) : 'No page check'
    //);

    //console.log('============================');

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    const userRole = user?.userRole?.trim().toLowerCase();

    // Check permissions for Admin users
    if (userRole === 'admin' && page) {
        const hasAccess = hasPageAccess(page, section);

        if (!hasAccess) {
            //console.log('Access denied:', {
            //    page,
            //    section,
            //    userRole,
            //    permissions: user?.userPermissions
            //});

            return <Navigate to="/" replace />;
        }
    }

    // Check allowed roles
    if (
        allowedRoles &&
        !allowedRoles.some(
            role => role.trim().toLowerCase() === userRole
        )
    ) {
        return <Navigate to="/" replace />;
    }

    return children;
};
